import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
const JSEncrypt_encrypt = new JSEncrypt();

/**
 * 生成随机的32位字符
 * @returns 
 */
export const GenerateRandomKey = () => {
    const random_key_32 = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
    return random_key_32;
}
/**
 * 字符串转base64
 * @param {*} str 字符串
 * @returns 
 */
export const StringToBase64 = (str) => {
    try {
        const wordArray = CryptoJS.enc.Utf8.parse(str);
        return CryptoJS.enc.Base64.stringify(wordArray);
    } catch (error) {
        console.error('Error:', error);
        return '';
    }
}

/**
 * base64转字符串
 * @param {*} str   需要转的base64字符
 * @returns         
 */
export const Base64ToString =  (base64Str) => {
    try {
        const wordArray = CryptoJS.enc.Base64.parse(base64Str);
        // 转换为字符串
        return CryptoJS.enc.Utf8.stringify(wordArray);
    } catch (error) {
        // console.error('转换失败:', error);
        return '';
    }
}
/**
 * 使用AES加密
 * @param {*} plaintext 需要加密的内容
 * @param {*} secretKey 密钥
 * @returns 
 */
export const AesEncrypt = (plaintext, secretKey) => {
    try {
        // 判断密钥格式并正确解析
        // 如果是 Hex 字符串（32个字符），使用 Hex.parse
        // 否则使用 Utf8.parse
        let key;
        if (secretKey.length === 32 && /^[0-9a-fA-F]+$/.test(secretKey)) {
            key = CryptoJS.enc.Hex.parse(secretKey);
        } else {
            key = CryptoJS.enc.Utf8.parse(secretKey);
        }

        // 1. AES 加密（ECB 模式 + PKCS7 填充）
        const encrypted = CryptoJS.AES.encrypt(
            plaintext,
            key,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // 2. 转 Base64
        const ciphertext = encrypted.toString();

        // console.log('加密结果:', ciphertext);
        return ciphertext;
    } catch (err) {
        // console.error('加密失败:', err);
        return null;
    }
}

/**
 * AES解密
 * @param {*} ciphertext    需要解密的内容
 * @param {*} secretKey     密钥
 * @returns 
 */
export const AesDecrypt = (ciphertext, secretKey) => {
    try {
        // 判断密钥格式并正确解析
        let key;
        if (secretKey.length === 32 && /^[0-9a-fA-F]+$/.test(secretKey)) {
            key = CryptoJS.enc.Hex.parse(secretKey);
        } else {
            key = CryptoJS.enc.Utf8.parse(secretKey);
        }

        // 1. Base64 解码
        const decodedData = CryptoJS.enc.Base64.parse(ciphertext);

        // 2. AES 解密（假设使用 ECB 模式 + PKCS7 填充）
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: decodedData }, // 直接传入已解析的密文
            key,
            {
                mode: CryptoJS.mode.ECB, // 根据加密时的模式调整（常见 CBC/ECB）
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // 3. 转 UTF-8 明文
        const plaintext = decrypted.toString(CryptoJS.enc.Utf8);

        // console.log('解密结果:', plaintext);
        return plaintext;
    } catch (err) {
        // console.error('解密失败:', err);
        return null;
    }
}

/**
 * 获取本地localstorage存储的内容
 * @param {*} key   键名
 * @returns         存储结果
 */
export const  GetLocalStorage = (key) => {
    let local_str = localStorage.getItem(key);
    if(local_str){
        if(local_str.indexOf('{') != -1){
            return JSON.parse(local_str)
        }else{
            return local_str
        }
    }else{
        return null
    }
}

/**
 * RSA 加密
 * @param {*} publicKeyString   公钥
 * @param {*} data              需要加密的内容
 * @returns                     加密后的结果
 */
export const RSAEncrypt = (publicKeyString,data)=>{
    try{
        JSEncrypt_encrypt.setPublicKey(publicKeyString);
        return JSEncrypt_encrypt.encrypt(data)
        // return JSEncrypt_encrypt.encrypt(data)
    }catch(error){
        throw new Error('Error: ' + error.message);
    }
}

/**
 * RSA解密
 * @param {*} key       解密私钥
 * @param {*} data      需要解密的内容
 * @returns             解密后的数据
 */
export const RSADecrypt = (key,data)=>{
    JSEncrypt_encrypt.setPublicKey(key);
    try{
        return JSEncrypt_encrypt.decrypt(data)
    }catch(error){
        throw new Error('Error: ' + error.message);
    }
}

/**
 * 获取浏览器信息
 * @returns 
 */
export const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserName = null;
    let version = null;

    if (userAgent.indexOf("Firefox") > -1) {
        browserName = "Firefox";
        version = userAgent.match(/Firefox\/(\d+\.\d+)/)[1];
    } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
        browserName = "Opera";
        version = userAgent.indexOf("Opera") > -1 ?
            userAgent.match(/Opera\/(\d+\.\d+)/) && userAgent.match(/Opera\/(\d+\.\d+)/)[1] :
            userAgent.match(/OPR\/(\d+\.\d+)/)[1];
    } else if (userAgent.indexOf("Edge") > -1) {
        browserName = "Edge";
        version = userAgent.match(/Edge\/(\d+\.\d+)/)[1];
    } else if (userAgent.indexOf("Chrome") > -1) {
        browserName = "Chrome";
        version = userAgent.match(/Chrome\/(\d+\.\d+)/)[1];
    } else if (userAgent.indexOf("Safari") > -1) {
        browserName = "Safari";
        version = userAgent.match(/Version\/(\d+\.\d+)/)[1];
    } else if (userAgent.indexOf("MSIE") > -1 || !!document.documentMode) {
        browserName = "IE";
        version = userAgent.match(/MSIE (\d+\.\d+)/) ?
            userAgent.match(/MSIE (\d+\.\d+)/)[1] :
            userAgent.match(/rv:(\d+\.\d+)/)[1];
    }

    return { browserName, version };
}

/**
 * 格式化时间戳
 * @param {时间戳/毫秒} timestamp 
 * @returns 
 */
export const formatDateTime =  (timestamp) => {
    if (!timestamp) return '-';
    timestamp = Number(timestamp);
    const date = new Date(timestamp);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}